import { Empty } from 'antd'
import { useTranslation } from 'react-i18next'

const EmptyData = ({ image = Empty.PRESENTED_IMAGE_DEFAULT }) => {
  const { t } = useTranslation()
  return <Empty image={image} description={t(`common.table.no-data`)} />
}

export default EmptyData
